import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { LayoutDashboard, Truck, Activity, DollarSign, TrendingUp, Wrench, Users, MapPin, BarChart3, Settings, HardHat, CreditCard, Landmark, ArrowLeftRight, Search } from 'lucide-react';

const pages = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard, keywords: 'home overview stats' },
  { name: 'Cranes', href: '/cranes', icon: Truck, keywords: 'fleet equipment crane machine' },
  { name: 'Operations', href: '/operations', icon: Activity, keywords: 'deploy work order' },
  { name: 'Revenue', href: '/revenue', icon: TrendingUp, keywords: 'income billing money' },
  { name: 'Expenses', href: '/expenses', icon: DollarSign, keywords: 'cost spend payment' },
  { name: 'Payments', href: '/payments', icon: CreditCard, keywords: 'pay bank transfer' },
  { name: 'Loans', href: '/loans', icon: Landmark, keywords: 'loan emi borrow' },
  { name: 'Cash Flow', href: '/cashflow', icon: ArrowLeftRight, keywords: 'cash bank flow' },
  { name: 'Maintenance', href: '/maintenance', icon: Wrench, keywords: 'service repair oil parts' },
  { name: 'Clients', href: '/clients', icon: Users, keywords: 'customer client company' },
  { name: 'Sites', href: '/sites', icon: MapPin, keywords: 'site location project' },
  { name: 'Employees', href: '/employees', icon: HardHat, keywords: 'staff employee worker' },
  { name: 'Analytics', href: '/analytics', icon: BarChart3, keywords: 'reports chart analysis' },
  { name: 'Settings', href: '/settings', icon: Settings, keywords: 'config backup setting' },
];

export function CommandBar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen(o => !o);
      }
    };
    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  const handleSelect = (href) => {
    setOpen(false);
    navigate(href);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="hidden md:flex items-center gap-2 px-3 py-1.5 text-sm text-muted-foreground bg-muted/50 hover:bg-muted border border-border rounded-md transition-colors"
        data-testid="command-bar-trigger"
      >
        <Search className="w-4 h-4" />
        <span>Search...</span>
        <kbd className="ml-4 text-[10px] font-mono bg-background/80 border border-border px-1.5 py-0.5 rounded">Ctrl+K</kbd>
      </button>
      <CommandDialog open={open} onOpenChange={setOpen}>
        <Command className="rounded-lg border shadow-md">
          <CommandInput placeholder="Search pages, cranes, sites..." />
          <CommandList>
            <CommandEmpty>No results found.</CommandEmpty>
            <CommandGroup heading="Pages">
              {pages.map((page) => (
                <CommandItem
                  key={page.href}
                  value={page.name + ' ' + page.keywords}
                  onSelect={() => handleSelect(page.href)}
                  className="cursor-pointer"
                >
                  <page.icon className="mr-2 h-4 w-4" />
                  <span>{page.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </CommandDialog>
    </>
  );
}
